import { cn } from "./cn";
import type { ChartSeries } from "./chart-types";
import "./chart-legend.css";

export interface ChartLegendProps {
  series: readonly Pick<ChartSeries, "key" | "label">[];
  colors: Map<string, string>;
  className?: string;
}

/**
 * A swatch + label per series. Required (dataviz house rule) the moment a
 * chart carries 2+ series, since identity must never rest on color alone;
 * LineAreaChart and BarChart render this automatically rather than leaving it
 * to a forgetful caller. A single-series chart needs no legend box (its
 * title + caption swatch already name it), so callers with one series simply
 * don't render this component.
 */
export function ChartLegend({ series, colors, className }: ChartLegendProps) {
  return (
    <ul className={cn("rc-chart-legend", className)}>
      {series.map((s) => (
        <li key={s.key} className="rc-chart-legend__item">
          <span
            className="rc-chart-legend__swatch"
            aria-hidden="true"
            style={{ background: colors.get(s.key) ?? "var(--rc-chart-other)" }}
          />
          {/* Ink, never the series color - the swatch beside it carries identity. */}
          <span className="rc-chart-legend__label">{s.label}</span>
        </li>
      ))}
    </ul>
  );
}
